import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { storeIdentity } from "../../../hooks/useApi";
import {FourPointStar, CrookedStar} from "../../../assets";

const IdentityForm = () => {
  const navigate = useNavigate();

  const [formData, setFormData] = useState({
    name: "",
    email: "",
    no_wa: "",
    source: "",
    agree: false,
  });

  const [errors, setErrors] = useState({});
  const [loading, setLoading] = useState(false);
  const [apiError, setApiError] = useState(null);

  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;
    const sanitizedValue = name === "no_wa" ? value.replace(/[^0-9]/g, "") : value;

    setFormData((prev) => ({
      ...prev,
      [name]: type === "checkbox" ? checked : sanitizedValue,
    }));
  };

  const validateForm = () => {
    const newErrors = {};
    if (!formData.name) newErrors.name = "Nama wajib diisi";
    if (!formData.email) newErrors.email = "Email wajib diisi";
    if (!formData.no_wa || formData.no_wa.length < 10) newErrors.no_wa = "No WA wajib diisi dan minimal 10 digit";
    if (!formData.source) newErrors.source = "Sumber wajib dipilih";
    if (!formData.agree) newErrors.agree = "Anda harus menyetujui penggunaan data";
    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!validateForm()) return;

    setLoading(true);
    setApiError(null);

    try {
      const response = await storeIdentity({
        name: formData.name,
        email: formData.email,
        no_wa: formData.no_wa,
        source: formData.source,
      });

      const identityId = response.data?.data?.id;
      const token = response.data?.token;

      if (identityId && token) {
        localStorage.setItem("identity_id", identityId);
        localStorage.setItem("token", token);
        navigate("/test");
      } else {
        throw new Error("ID atau Token tidak ditemukan di response!");
      }
    } catch (error) {
      console.error("Error submitting biodata:", error);
      setApiError("Gagal mengirim biodata. Silakan coba lagi.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <section className="relative isolate pb-4 pt-2 sm:pb-6">
      <div className="relative mx-auto w-full max-w-[900px] overflow-visible rounded-[24px] bg-[#222D6A] px-5 py-6 shadow-[0_10px_20px_rgba(0,0,0,0.18)] sm:px-6 sm:py-7 lg:max-w-4xl lg:px-8 lg:py-8">
        <img
          src={FourPointStar}
          alt=""
          className="pointer-events-none absolute left-[-36px] top-[18%] z-10 hidden w-[86px] sm:block lg:left-[-58px] lg:w-[106px]"
          loading="lazy"
        />
        <img
          src={CrookedStar}
          alt=""
          className="pointer-events-none absolute right-[-76px] top-[44%] z-10 hidden w-[126px] sm:block lg:right-[-76px] lg:w-[128px]"
          loading="lazy"
        />

        <div className="relative z-20">
          <h2 className="st-font-display text-[36px] leading-none text-[#FFF7EB] sm:text-[40px] lg:text-[54px]">
          <span className="font-semibold italic">Kenalan</span>
          <span className="font-normal not-italic"> dulu, Yuk!</span>
          </h2>

          <form onSubmit={handleSubmit} className="mt-3.5 space-y-3 sm:space-y-3.5 lg:mt-4 lg:space-y-4">
          <div>
            <input
              type="text"
              name="name"
              value={formData.name}
              onChange={handleChange}
              className="st-font-body st-focus-ring w-full rounded-[8px] border border-transparent bg-[#F6F2E9] px-3.5 py-2 text-[13px] text-[#242424] placeholder:text-[#787878] sm:text-[14px] lg:px-4 lg:py-2.5 lg:text-[16px]"
              placeholder="Nama"
            />
            {errors.name && <p className="st-font-body mt-1 text-[12px] text-[#FFD8D1]">{errors.name}</p>}
          </div>

          <div>
            <input
              type="email"
              name="email"
              value={formData.email}
              onChange={handleChange}
              className="st-font-body st-focus-ring w-full rounded-[8px] border border-transparent bg-[#F6F2E9] px-3.5 py-2 text-[13px] text-[#242424] placeholder:text-[#787878] sm:text-[14px] lg:px-4 lg:py-2.5 lg:text-[16px]"
              placeholder="Email"
            />
            {errors.email && <p className="st-font-body mt-1 text-[12px] text-[#FFD8D1]">{errors.email}</p>}
          </div>

          <div>
            <input
              type="tel"
              name="no_wa"
              value={formData.no_wa}
              onChange={handleChange}
              className="st-font-body st-focus-ring w-full rounded-[8px] border border-transparent bg-[#F6F2E9] px-3.5 py-2 text-[13px] text-[#242424] placeholder:text-[#787878] sm:text-[14px] lg:px-4 lg:py-2.5 lg:text-[16px]"
              placeholder="Nomor Whatsapp Aktif"
            />
            {errors.no_wa && <p className="st-font-body mt-1 text-[12px] text-[#FFD8D1]">{errors.no_wa}</p>}
          </div>

          <div className="relative">
            <select
              name="source"
              value={formData.source}
              onChange={handleChange}
              className="st-font-body st-focus-ring w-full appearance-none rounded-[8px] border border-transparent bg-[#F6F2E9] px-3.5 py-2 pr-9 text-[13px] text-[#5A5A5A] sm:text-[14px] lg:px-4 lg:py-2.5 lg:pr-10 lg:text-[16px]"
            >
              <option value="" disabled>
                Tau Scholars Today darimana?
              </option>
              <option value="Website Scholars Today">Website Scholars Today</option>
              <option value="Google Search">Pencarian Google</option>
              <option value="Blog Scholars Today">Blog Scholars Today</option>
              <option value="Sosial media">Sosial media</option>
              <option value="Admin Scholars Today">Admin Scholars Today</option>
              <option value="Freands">Teman/Kerabat</option>
            </select>
            <span className="pointer-events-none absolute right-3 top-1/2 -translate-y-1/2 text-[11px] text-[#5A5A5A] lg:right-4 lg:text-[12px]">▼</span>
            {errors.source && <p className="st-font-body mt-1 text-[12px] text-[#FFD8D1]">{errors.source}</p>}
          </div>

          <div>
            <label className="inline-flex items-center gap-2 text-[12px] text-[#FFF7EB] sm:text-[13px] lg:text-[14px]">
              <input
                type="checkbox"
                name="agree"
                checked={formData.agree}
                onChange={handleChange}
                className="h-4 w-4 accent-[#F4C82A]"
              />
              <span className="st-font-body">Izinkan Minday buat nyapa kamu langsung!</span>
            </label>
            {errors.agree && <p className="st-font-body mt-1 text-[12px] text-[#FFD8D1]">{errors.agree}</p>}
          </div>

          {apiError && <p className="st-font-body text-[12px] text-[#FFD8D1]">{apiError}</p>}

            <div className="pt-1 text-right">
              <button
                type="submit"
                disabled={loading}
                className="st-focus-ring st-font-body rounded-full bg-[#F4C82A] px-5 py-1.5 text-[16px] font-bold text-[#FFFFFF] transition-colors duration-200 hover:bg-[#E9BC1D] disabled:cursor-not-allowed disabled:opacity-80 lg:px-6 lg:py-2 lg:text-[18px]"
              >
                {loading ? "Mengirim..." : "Mulai Tes!"}
              </button>
            </div>
          </form>
        </div>
      </div>
    </section>
  );
};

export default IdentityForm;
